import * as t from 'io-ts';
import { BaseHandler } from "../../models";
import { createCodec } from "../../modelUtils";
export var Handler = createCodec('Handler', function (h) {
    return BaseHandler.is(h);
});
export var PluginClientHandlerCollection = t.record(t.string, Handler);
//# sourceMappingURL=models.js.map